/**
 * 快捷短语
 * TODO
 * 2、动态push逻辑
 */
import $ from '@ali/tarzan-zepto';
import events from 'events';
import tpl from './tpl.html';
import { getTranslation as translate } from '../../../utils';
import util from '../../../lib/util.js';
import './style.scss';

const clickType = util.click();

export default class Shortcuts extends events {
  constructor(app) {
    super();
    this.app = app;
    this.$container = app.view.footer.$endConversationHolder;
    this.render();
    this.bindEvents();
  }
  render() {
    // const clicked = this.app.util.storage.getItem(STORAGE_SHORTCUT);
    // const clickedList = (clicked ? JSON.parse(clicked) : []) || [];
    const data = {
      cancel: translate('csc.label.cancel'),
      leave: translate('csc.label.leave'),
      confirmLeaving: translate('csc.system.confirm_leaving'),
    };
    this.$node = $(tpl.render(data));
    this.$container.empty().append(this.$node);
  }

  confirmConversationLeaving() {
    this.app.emit(this.app.events.AGENT_END_CHAT);
  }

  bindEvents() {
    this.$container
      .delegate('#end-conversation-confirm-button', clickType, ev => this.confirmConversationLeaving(ev));

    this.$container
      .delegate('#end-conversation-cancel-button', clickType, ev => this.hidePopup(ev));
  }

  hidePopup() {
    this.$container.addClass('-hidden');
  }
}



// WEBPACK FOOTER //
// ./src/app/module/end-conversation-confirmation/end-conversation-confirmation.js